import { useCallback } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { Checkbox } from '@clds/checkbox';
import { InlineFieldLayout, Label } from '@clds/form';
import t from 'common/i18n';
import { useFilterParams } from '../../selectors';
import { RESOLUTION_OPTIONS } from '../../filterConsts';
import { SectionBox } from './Filters.styles';

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${globalTheme.spacing.xs};
  label {
    font-weight: normal;
    padding: 0px;
    padding-left: ${globalTheme.spacing.xxs};
  }
`;

export default ({ handleSearch, source }) => {
  const { formatAvailable } = useFilterParams(source);

  const filterChange = useCallback(
    (item) => {
      const newResolution = formatAvailable.includes(item) ? formatAvailable.filter((r) => r !== item) : [...formatAvailable, item];
      handleSearch({
        filters: {
          formatAvailable: newResolution,
        },
      });
    },
    [handleSearch, formatAvailable]
  );

  return (
    <SectionBox data-test="resolution-section">
      <label>{t(`${source}.filters.resolution.label`)}</label>
      <ResolutionList resolution={formatAvailable} filterChange={filterChange} />
    </SectionBox>
  );
};

const ResolutionList = ({ resolution, filterChange }) =>
  RESOLUTION_OPTIONS.map((item) => {
    const onClick = () => {
      filterChange(item);
    };
    return (
      <CheckboxContainer key={item}>
        <InlineFieldLayout
          label={
            <Label htmlFor={item} data-test={item}>
              {item}
            </Label>
          }
        >
          <Checkbox id={item} value={resolution.includes(item)} onClick={onClick} />
        </InlineFieldLayout>
      </CheckboxContainer>
    );
  });
